(function($) {

	'use strict';

	function init(){
		$(document).on('gform_post_render', displayMonthNames);
	};

	function displayMonthNames(event, form_id, current_page){
		if( form_id == ActivateServiceForm.formId ){
			const form = $('#gform_'+form_id);
			form.find('.gfield_date_dropdown_month select option').each((i, e) => {
				const optionItem = $(e);
				const value = optionItem.attr("value");
				if( value && value in ActivateServiceForm.monthsNames ){
					optionItem.text( ActivateServiceForm.monthsNames[optionItem.attr("value")] );
				}
			})
		}
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
